<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">
      <div class="card">
        <div class="card-title d-flex justify-content-between align-items-center">          
          <div class="d-flex justify-content-start align-items-center">            
            <div>
              <div class="pl-2 pt-1 align-items-left">
                <h4>Envíos Apacargo</h4>
              </div>              
            </div>             
          </div>  
          <div class="d-flex justify-content-between pl-2">
            <button
              class="btn btn-warning mt-2 mr-1 text-nowrap"
              rippleEffect
                 (click)="OpenHistoryModal()"                              
            >
            <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block text-nowrap">Historial</span>
            </button>    
                     
            <button type="button" class="btn btn-primary mt-2 mr-1 text-nowrap" rippleEffect (click)="FetchShipments()">
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
                ><span class="d-none d-sm-inline-block text-nowrap">Cargar Envíos</span>
            </button>
            <input type="file" id="files" #fileInput style="display: none">
          </div>                 
        </div>
        <div class="card-subtitle mb-2 text-muted d-flex justify-content-between align-items-center">
          <div class="align-items-center pl-2" style="font-size: 10; padding-top: 5px;">
            <!--{{ alreadyRegisteredBillsMsg }}-->
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 col-12">
            <div
              class="d-flex justify-content-between align-items-center m-1"
            >
              <label class="d-flex align-items-center"
                >Mostrando
                <select
                  class="form-control mx-25"
                  [(ngModel)]="basicSelectedOption"
                >
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="15">15</option>           
                  <option *ngIf="alloperations.length > 15" [value]="alloperations.length">Todos</option>                                 
                </select>
                envíos</label
              >
            </div>
          </div>
          <div class="col-md-6 col-12 d-flex justify-content-md-end">
            <div
              class="d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0"
            >
              <label class="d-flex align-items-center"
                >Buscar<input
                  #searchInput
                  type="search"
                  placeholder="Código Factura"
                  class="form-control ml-25" (keyup)="FilterUpdate(searchInput.value)"
                  (search)="FilterUpdate(searchInput.value)"

              /></label>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 col-12">
          <ngx-datatable #table ngx-resize-watcher
              [rows]="alloperations"
              [rowHeight]="58"
              class="bootstrap core-bootstrap"            
              [columnMode]="ColumnMode.flex"
              [headerHeight]="40"
              [footerHeight]="50"
              [scrollbarH]="true"
              [limit]="basicSelectedOption"           
              [messages]="{
                emptyMessage: 'No hay información para mostrar',
                totalMessage: 'Total de envios'
              }"
            >             
            <ngx-datatable-column name="No" prop="shipmentNumber" [flexGrow]="1">
              <ng-template let-shipment="value" ngx-datatable-cell-template>   
                <!--[ngbTooltip]="TooltipHelper(code)"-->             
                <a (click)="ConfirmProcessAsAdmin(shipment)" target="_self" placement="right" ngbTooltip="Click para procesar" >
                  {{ shipment }}
                </a>        
              </ng-template>            
            </ngx-datatable-column>
            <ngx-datatable-column name="Servicio" prop="serviceName" [flexGrow]="1">
              <ng-template let-service="value" ngx-datatable-cell-template>
                {{ service }}  
                <!--<div
                  placement="left"
                  [ngbTooltip]="'Nombre: ' + sender?.senderFullName"
                >
                  <span
                    class="d-inline-block text-truncate"
                    style="max-width: 150px"
                    >{{ sender?.senderCellPhone | limitText }}</span
                  >
                </div>   -->   
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Órdenes" prop="orderCount" [flexGrow]="1">
              <ng-template let-order="value" ngx-datatable-cell-template>              
                {{ order }}       
              </ng-template>
            </ngx-datatable-column>            
            <ngx-datatable-column name="Bultos" prop="orderProductCount" [flexGrow]="1">
              <ng-template let-order="value" ngx-datatable-cell-template>
                {{ order }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Peso" prop="netWeight" [flexGrow]="1">
              <ng-template let-net="value" ngx-datatable-cell-template>
                {{ net }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column name="Fecha envio" prop="dateCreated" [flexGrow]="1">
              <ng-template let-date="value" ngx-datatable-cell-template>
                {{ date | date : "mediumDate"}}
              </ng-template>
            </ngx-datatable-column>
            
            <ngx-datatable-footer *ngIf="true">
              <ng-template
                ngx-datatable-footer-template
                let-rowCount="rowCount"
                let-pageSize="pageSize"
                let-selectedCount="selectedCount"
                let-curPage="curPage"
                let-offset="offset"
              >
              <div class="d-flex justify-content-between w-100">
                <div class="col-7 col-lg-7 col-sm-7" style="padding: 5px 10px">                
                  <div>Total envíos: {{ rowCount }} </div>
                </div>
                <div class="col-5 col-lg-5 col-sm-5 align-items-center align-self-end text-right text-nowrap">
                    <datatable-pager
                    [pagerLeftArrowIcon]="'datatable-icon-left'"
                    [pagerRightArrowIcon]="'datatable-icon-right'"
                    [pagerPreviousIcon]="'datatable-icon-prev'"
                    [pagerNextIcon]="'datatable-icon-skip'"
                    [page]="curPage"
            [visiblePagesCount]="currentVisible"
            [size]="pageSize"
            [count]="rowCount"
            [hidden]="!((rowCount / pageSize) > 1)"
            (change)="table.onFooterPage($event)">                
                </datatable-pager>
                  </div>
              </div>
              
              
                
                
              </ng-template>
            </ngx-datatable-footer>
            </ngx-datatable>
            </div></div></div>
      </div>
      <ng-template #popoverTemplate> 
        <div class="col-md-12 col-12">
          <div class="row pb-1">
              <div class="col-md-12">
                  <button type="button" class="close" (click)="popOver.close()" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              
          </div>  
          Procesar factura como administrador                     
          <button type="button" ngbTooltip="Eliminar" placement="left"
                                        class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-50"
                                        rippleEffect >
                                        <span [data-feather]="'trash-2'"></span></button>
      </div>             
      </ng-template>
    </section>
  </div>
</div>
